export default __webpack_public_path__ + "static/media/kuwai-coin.cc43cb60.png";